import React from 'react';
import { useNavigate } from 'react-router-dom';

import BounceLoader from '@common/react/components/UI/Loaders/BounceLoader';
import { List } from '@common/typescript/objects/List';

import { rest } from '@app/components/Api';
import SimpleMap from '@app/components/UI/SimpleMap/SimpleMap';
import line from '@app/images/highlight_text_dark.svg';
import { ListOption } from '@app/objects/SidebarProps';
import { StatesListItem } from '@app/objects/StatesListItem';
import { transformStateList } from '@app/utils/transformList';

const BlockWithMap: React.FC = () => {
	const navigate = useNavigate();
	const [states, setStates] = React.useState<Array<StatesListItem>>([]);
	const [isLoadingStates, setIsLoadingStates] = React.useState<boolean>(true);
	const stateListOptions: Array<ListOption> = [];

	React.useEffect(() => {
		rest.get<List<StatesListItem>>('v1/states/')
			.then((res) => setStates(res.list))
			.finally(() => setIsLoadingStates(false));
	}, []);

	transformStateList(states, stateListOptions);

	return (
		<section className="block-map">
			<div className="block-map-wrap">
				<div className="block-map-wrap__text">
					<h3>The Industry Leader in End-of-Life Veterinary Care</h3>
					<p>
						Lap of Love has helped thousands of clinics across the country relieve the stress that euthanasia appointments can bring. We
						build strong relationships with veterinarians and their teams by providing information and education and by serving as a
						trusted resource and partner to turn to for your families in need of end-of-life care for their pets.
					</p>
					<ul>
						<li>Assisted over one million pets and families</li>
						<li>Over 450 veterinarians across the US in 40+ states</li>
						<li>Dedicated phone center support available 24 hours a day, 7 days a week, 365 days a year</li>
						<li>In-home euthanasia, pet hospice, telehospice, and pet loss support services available</li>
						<li>Delivered over 1K hours of educational speaking in the industry</li>
					</ul>
				</div>
				<div className="block-map-wrap__simpleMap">
					{!isLoadingStates ? (
						<SimpleMap
							states={states}
							getTooltip={(state) => `${state.veterinarians} local vets`}
							getFillColor={(state) => (state.veterinarians > 0 ? '#c4bacf' : '#e1dce6')}
							onClick={(state) => navigate(`/find-a-vet/search?query=${state.name}`)}
						/>
					) : <BounceLoader />}
				</div>
			</div>
			<img src={line} alt="line" className="line" />
		</section>
	);
};

export default BlockWithMap;
